import React from 'react'
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import _ from 'lodash';

//  CSS
import './../../assets/styles/style.scss';
import './wallet.scss';
import ScanQR from './../../assets/images/icons/scan_qr.svg';
import { Link } from 'react-router-dom';

import { Button } from 'antd';
import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData, getUserData } from './../../components/Util';

import Modal from '@mui/material/Modal';
import QrReader from 'react-qr-scanner'
import LoaderContext from '../../components/Loader/LoaderContext.js';

class WithdrawalScreen extends React.Component {

    static contextType = LoaderContext;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            access_token: "",
            bank_id: 1,
            wallet_address: "",
            amount: '',
            user_data: {},
            isModal: false,
            verification_code: '',
            otp_code: '',
        }
    }

    async componentDidMount() {
        var token = await getToken();
        if (token) {
            await storeUserData(token);
            setTimeout(() => {
                this.setState({ access_token: token });
                var rowData = getUserData();
                if (rowData.data) {
                    this.setState({
                        user_data: rowData.data
                    });
                }
            });
        }
    }

    sendCode() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {
            setLoading(true);
            axios({
                method: 'POST',
                url: api.withdraw_send_code,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage()
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    self.setState({ otp_code: ress.data.data.otp_code });
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                }
                setLoading(false);
            }).catch(function (e) {
                setLoading(false);
            });
        }
    };

    sendData() {
        const { setLoading } = this.context;
        var self = this;
        if (self.state.access_token) {

            setLoading(true);
            var json = {
                // bank_id: self.state.bank_id,
                wallet_address: self.state.wallet_address,
                amount: self.state.amount,
                verification_code: self.state.verification_code,
            }

            self.setState({ loading: true });
            axios({
                method: 'POST',
                url: api.withdraw_store,
                data: json,
                headers: {
                    'Authorization': 'Bearer ' + self.state.access_token,
                    'Content-Type': 'application/json',
                    'Accept-Language': strings.getLanguage()
                }
            }).then(function (ress) {
                if (ress.data && ress.data.error === 200) {
                    setLoading(false);
                    toast.success(ress.data.message);
                    self.props.history.replace({ pathname: `/withdrawal-details` })
                } else {
                    if (ress.data.validation && ress.data.validation.length !== 0) {
                        _.forEach(ress.data.validation, function (value) {
                            if (value[0]) {
                                toast.error(value[0]);
                            }
                        });
                    } else {
                        toast.error(ress.data.message);
                    }
                    setLoading(false);
                }
                setLoading(false);
                self.setState({ loading: false });
            }).catch(function (e) {
                setLoading(false);
                self.setState({ loading: false });
            });
        }
    };

    closeModal() {
        var self = this;
        self.setState({
            isModal: false,
        });
    }

    render() {
        const availableUsdt = (this.state.user_data && this.state.user_data.credit && this.state.user_data.credit.usdt)
            ? parseFloat(this.state.user_data.credit.usdt).toFixed(5)
            : "0.00000";
        const amountValue = Number(this.state.amount || 0);
        const withdrawalFee = 2;
        const receiveAmount = Math.max(amountValue - withdrawalFee, 0).toFixed(5);

        return (
            <>
                <SubLayout ref={this.wrapper} data={{ "title": strings.withdrawal }}>
                    <div className='wallet-page'>
                        <div className='wallet-form-shell'>
                            <div className='wallet-form-header'>
                                <div>
                                    <h2>{strings.withdrawal}</h2>
                                    <p>Send USDT out securely with full fee and receive amount visibility.</p>
                                </div>
                                <Link to={"/withdrawal-details"} className='wallet-top-link'>{strings.Withdraw_details}</Link>
                            </div>

                            <div className='wallet-form-card'>
                                <div className='wallet-form-intro'>
                                    <div>
                                        <h3>{strings.confirm_withdrawal}</h3>
                                        <p>Use a valid BEP20 address and review the net amount before confirming.</p>
                                    </div>
                                    <div className='wallet-chain-badge'>BEP20</div>
                                </div>

                                <div className='wallet-form-grid'>
                                    <div className='wallet-field'>
                                        <label>{strings.withdrawal_address}</label>
                                        <div className='wallet-input-wrap'>
                                            <input
                                                name='wallet_address'
                                                onChange={e => this.setState({ wallet_address: e.target.value })}
                                                value={this.state.wallet_address}
                                                placeholder={strings.withdrawal_address_enter}
                                            />
                                            <img
                                                onClick={() => this.setState({ isModal: true })}
                                                src={ScanQR}
                                                alt="Scan QR"
                                                className='wallet-inline-icon'
                                            />
                                        </div>
                                    </div>

                                    <div className='wallet-field'>
                                        <label>{strings.withdrawal_quantity}</label>
                                        <div className='wallet-input-wrap'>
                                            <input
                                                name='amount'
                                                onChange={e => this.setState({ amount: e.target.value })}
                                                value={this.state.amount}
                                                placeholder={strings.minimum_withdraw_amount}
                                            />
                                            <button
                                                type="button"
                                                className='wallet-inline-action'
                                                onClick={() => this.setState({ amount: availableUsdt })}
                                            >
                                                {strings.All}
                                            </button>
                                        </div>
                                    </div>

                                    <div className='wallet-field'>
                                        <label>{strings.verification_code}</label>
                                        <div className='wallet-code-row'>
                                            <div className='wallet-input-wrap'>
                                                <input
                                                    type="text"
                                                    name='verification_code'
                                                    onChange={e => this.setState({ verification_code: e.target.value })}
                                                    value={this.state.verification_code}
                                                    placeholder={strings.verification_code_enter}
                                                />
                                            </div>
                                            <Button
                                                loading={this.state.loading_code}
                                                onClick={() => this.sendCode()}
                                                className='wallet-code-button'
                                            >
                                                {this.state.loading_code ? strings.loading : strings.send_code}
                                            </Button>
                                        </div>
                                    </div>

                                    <div className='wallet-summary'>
                                        <div className='wallet-summary-row'>
                                            <span>{strings.Available}</span>
                                            <strong>{availableUsdt} {strings.usdt}</strong>
                                        </div>
                                        <div className='wallet-summary-row'>
                                            <span>{strings.Transaction_Fees}</span>
                                            <strong>{withdrawalFee} {strings.usdt}</strong>
                                        </div>
                                        <div className='wallet-summary-row'>
                                            <span>{strings.receive_amount}</span>
                                            <strong>{receiveAmount} {strings.usdt}</strong>
                                        </div>
                                    </div>

                                    <div className='wallet-disclaimer'>
                                        <h4>{strings.risk_disclaimer}</h4>
                                        <div>{strings.withdrawal_risk_disclaimer_point_1}</div>
                                        <div>{strings.withdrawal_risk_disclaimer_point_2}</div>
                                        <div>{strings.withdrawal_risk_disclaimer_point_3}</div>
                                    </div>

                                    <Button
                                        onClick={() => this.sendData()}
                                        className='wallet-primary-button'
                                        loading={this.state.loading}
                                    >
                                        {(this.state.loading) ? strings.loading : strings.confirm_withdrawal}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </SubLayout>

                <Modal
                    open={this.state.isModal ?? false}
                    className="itemModal"
                    onClose={() => this.closeModal()}
                    style={{ overflow: 'scroll' }}
                >
                    <>
                        <div className="modal-dialog modal-dialog-centered modal-fullscreen">
                            <div className="modal-content" style={{ background: "#616162" }}>
                                <div className="modal-header" style={{ width: "100%" }}>
                                    <span style={{ color: "#FFF" }}>{strings.Scan_QR_Code}</span>
                                    <button onClick={() => this.closeModal()}
                                        type="button" className="close" data-dismiss="modal" aria-label="Close"
                                        style={{ background: "transparent", borderWidth: 0 }}
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <QrReader
                                            style={{
                                                width: '100%',
                                            }}
                                            delay={300}
                                            facingMode="rear"
                                            onScan={(result, error) => {
                                                if (!!result) {
                                                    this.setState({
                                                        wallet_address: result.text,
                                                        isModal: false,
                                                    });
                                                }

                                                if (!!error) { }
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                </Modal>
            </>
        );
    }
}

export default WithdrawalScreen;
